module.exports = __webpack_public_path__ + "static/media/cherry.1cd68272.png";